import { App } from "vue";

import UIIcon from "./elements/UIIcon.vue";
import UIImage from "./elements/UIImage.vue";
import PrimaryBtn from "./elements/PrimaryBtn.vue"
import BlurImage from "./elements/BlurImage.vue";
import SimpleImage from "./elements/SimpleImage.vue";
import ScrollUp from "./elements/ScrollUp.vue";

import ChapterData from "./blocks/ChapterData.vue";

import LineByLine from "./animations/LineByLine.vue";
import Parallax from "./animations/Parallax.vue";
import Appear from "./animations/Appear.vue";

import PixelPerfectGrid from "./elements/PixelPerfectGrid.vue"

const register = (app: App<Element>): void => {
  app.component("ui-icon", UIIcon);
  app.component("ui-image", UIImage);
  app.component("primary-btn", PrimaryBtn);
  
  app.component("pixel-perfect-grid", PixelPerfectGrid);
  app.component("simple-image", SimpleImage);
  app.component("blur-image", BlurImage);
  app.component("scroll-up", ScrollUp);

  app.component("chapter-data", ChapterData);

  app.component("line-by-line", LineByLine);
  app.component("parallax", Parallax);
  app.component("appear", Appear);
};

export default { register };